import {SHIPPER_VENDORS} from '../../../common/constants/ShipperNames.js'
import {
  isLabelPropertyEnabledSelector,
  LABEL_PROPERTY_INCLUDE_ADDITIONAL_PROPERTIES,
  shipperTypesSelector,
} from '../../../data/labelInfos/index.js'
import {useSelector} from '../../../store.js'
import AdditionalOptionsSummary from '../AdditionalOptionsSummary.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import MultiboxButton from './MultiboxButton.js'
import useLabelProperty, {
  defaultValidLabelPropertiesFunc,
  EMPTY_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

export default function IncludeAdditionalProperties() {
  const {labelInfoID, shipperType, isSummary, isPickMode} =
    useLabelConfigContext()
  const propertySpecs = IncludeAdditionalProperties.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const shipperTypes = useSelector((state) =>
    shipperTypesSelector(state, {labelInfoID}),
  )
  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  if (isSummary) {
    return 'Additional Carrier Options'
  }

  if (isPickMode && !isLabelPropertyEnabled) {
    return (
      <PickLabelProperty
        label="Additional Carrier Options"
        labelProperty={labelProperty}
      />
    )
  }

  return (
    <>
      <li className="list__item--shipping-options list__item--shipping-options-rs flex-grow">
        <div className="flex--justify w-100">
          <div className="w-80">
            <p className="fs-00 lh-lg margin-bottom-10">
              <strong>Additional Carrier Options</strong>
            </p>

            <ul className="list list--no-style">
              {shipperTypes.map((shipperType) => (
                <AdditionalOptionsSummary
                  key={shipperType}
                  shipperType={shipperType}
                  singleShipperType={shipperTypes.length === 1}
                />
              ))}
            </ul>
          </div>
          <EnableLabelProperty labelProperty={labelProperty} />
        </div>
      </li>
      <MultiboxButton />
    </>
  )
}

IncludeAdditionalProperties.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY_INCLUDE_ADDITIONAL_PROPERTIES]
    },
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
